// extracted by mini-css-extract-plugin
module.exports = {"content":"authLayout_content__z5RmF","container":"authLayout_container__3r42c","footer":"authLayout_footer__2FUtj"};